var btn = $(".play");
btn.click(function () {
    btn.toggleClass("paused");
    return false;
});

$(".play").on("click", function () {
    if ($(this).attr("data-click") == 1) {
        $(this).attr("data-click", 0);
        $("#who video")[0].pause();
    } else {
        $(this).attr("data-click", 1);
        $("#who video")[0].play();
    }
});

$(".speaker").click(function (e) {
    e.preventDefault();

    $(this).toggleClass("mute");

    if ($("#who video").prop("muted")) {
        $("#who video").prop("muted", false);
    } else {
        $("#who video").prop("muted", true);
    }
});


var video = $("#who video")[0]; // Get the video element
var progress = $(".progress"); // Get the progress indicator element
var progressBar = $(".progress-bar"); // Get the progress bar element

// Update the progress bar and indicator as the video plays
video.addEventListener("timeupdate", function () {
    var currentTime = video.currentTime;
    var duration = video.duration;
    var percentage = (currentTime / duration) * 100;
    progress.width(percentage + "%");
});

// Allow the user to seek by clicking on the progress bar
progressBar.click(function (e) {
    var progressBarWidth = progressBar.width();
    var clickX = e.pageX - progressBar.offset().left;
    var seekTime = (clickX / progressBarWidth) * video.duration;
    video.currentTime = seekTime;
});

// Update the progress bar width if the video's metadata is loaded
video.addEventListener("loadedmetadata", function () {
    var duration = video.duration;
    var currentTime = video.currentTime;
    var percentage = (currentTime / duration) * 100;
    progress.width(percentage + "%");
});


// SLIDER
const progressLine = document.querySelector('.inside-bar1');
var swiper = new Swiper(".mySwiper", {
    effect: "fade",
    loop: true,
    autoplay: {
        delay: 3000,
        disableOnInteraction: false
    },
    on: {
        autoplayTimeLeft(s, time, progress) {
            progressLine.style.setProperty("--progress", progress);
        }
    }

});

const progressLine2 = document.querySelector('.inside-bar2');
var swiper2 = new Swiper(".mySwiper2", {
    effect: "fade",
    loop: true,
    autoplay: {
        delay: 3000,
        disableOnInteraction: false
    },
    on: {
        autoplayTimeLeft(s, time, progress) {
            progressLine2.style.setProperty("--progress", progress);
        }
    }
});

const progressLine3 = document.querySelector('.inside-bar3');
var swiper2 = new Swiper(".mySwiper3", {
    effect: "fade",
    loop: true,
    autoplay: {
        delay: 3000,
        disableOnInteraction: false
    },
    on: {
        autoplayTimeLeft(s, time, progress) {
            progressLine3.style.setProperty("--progress", progress);
        }
    }
});



